import comp from "./FeedButton";
export default comp;
